import { createPageSchema as e } from "../common/index.js";
import { deviceContextSchema as t, userSummarySchema as n } from "./base.js";
import { z as r } from "zod";
// src/identity/review.ts
var i = r.object({
	id: r.string().uuid(),
	user: n,
	createdAt: r.iso.datetime(),
	lastActivityAt: r.iso.datetime(),
	absoluteExpiresAt: r.iso.datetime(),
	idleExpiresAt: r.iso.datetime(),
	deviceContext: t
}), a = e(i), o = r.object({
	sessionId: r.string().uuid(),
	revokedAt: r.iso.datetime()
}), s = r.object({
	id: r.string().uuid(),
	actorKind: r.enum([
		"user",
		"system",
		"deployment",
		"unknown"
	]),
	actorRef: r.string().uuid().nullable(),
	subjectUserId: r.string().uuid().nullable(),
	action: r.string().min(1).max(100),
	occurredAt: r.iso.datetime(),
	deviceContext: t,
	outcome: r.enum([
		"success",
		"refused",
		"unavailable",
		"abandoned"
	]),
	reasonCode: r.string().max(100).nullable(),
	changes: r.union([r.object({
		oldRole: r.enum(["Agent", "Admin"]).nullable(),
		newRole: r.enum(["Agent", "Admin"]).nullable()
	}), r.object({
		oldState: r.enum(["active", "deactivated"]),
		newState: r.enum(["active", "deactivated"])
	})]).nullable(),
	retentionClass: r.enum(["routine", "security"]),
	correlationId: r.string().uuid()
}), c = e(s);
export { c as authenticationEventPageSchema, s as authenticationEventSummarySchema, o as revocationResultSchema, a as sessionPageSchema, i as sessionSummarySchema };

//# sourceMappingURL=review.js.map